import React from 'react';
import { Alert, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Shown in every dialog that moves a calendar slot whose work order has a linked online
 * booking. The booking follows the slot regardless; the checkbox decides whether the customer
 * gets the "your time has changed" SMS/email (backend flag notify_customer, default on).
 *
 * `showChoice` false hides the checkbox: the backend never messages when only the duration
 * changed, so offering the choice for a pure resize would contradict the result.
 */
export default function BookingNotifyChoice({ checked, onChange, showChoice = true, sx }) {
  const { t } = useTranslation();
  return (
    <Alert severity="info" sx={{ borderRadius: '8px', ...sx }} data-testid="booking-linked-alert">
      <Typography variant="body2" sx={{ mb: showChoice ? 0.5 : 0 }}>
        {showChoice ? t('booking_linked_reschedule_warning') : t('booking_linked_duration_only')}
      </Typography>
      {showChoice && (
        <FormControlLabel
          sx={{ ml: 0 }}
          control={
            <Checkbox
              size="small"
              checked={checked}
              onChange={(e) => onChange(e.target.checked)}
              data-testid="booking-notify-customer"
            />
          }
          label={<Typography variant="body2">{t('booking_linked_notify_customer')}</Typography>}
        />
      )}
    </Alert>
  );
}
